import React, { useState, useEffect, useMemo } from "react";
import { Search, ArrowLeft } from "lucide-react";
import { toast } from "react-toastify";
import {
  fetchClientsByStatus,
  approveClient,
  rejectClient,
} from "../../../services/admin/api";
import "./client-list.css";
import { useNavigate } from "react-router-dom";
const PendingClients = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);

  const [sortColumn, setSortColumn] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("");
  const [isAsc, setIsAsc] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [searchTerm, setSearchTerm] = useState("");

  const [processing, setProcessing] = useState(false);
  const [actionState, setActionState] = useState({ id: null, type: null });
  const [rejectReason, setRejectReason] = useState("");

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    id: null,
    type: null,
  });

  const loadClients = async () => {
    try {
      setLoading(true);

      const res = await fetchClientsByStatus(
        "PENDING",
        currentPage,
        itemsPerPage,
        sortColumn,
        isAsc,
        searchTerm,
      );

      if (res?.content) {
        setClients(res.content);
        setTotalPages(res.totalPages);
        setTotalElements(res.totalElements);
        setPageSize(res.size);
      } else {
        setClients([]);
        setTotalPages(0);
      }
    } catch (err) {
      console.error("Error loading pending clients:", err);
      toast.error("Failed to load pending clients");
      setClients([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ CALL API WHEN ANYTHING CHANGES
  useEffect(() => {
    loadClients();
  }, [currentPage, itemsPerPage, sortColumn, isAsc, searchTerm]);

  const renderSortArrow = (field) => {
    const isActive = sortColumn === field;

    return (
      <span className={`sort-icons ${isActive ? "sort-active" : ""}`}>
        {/* showing the next action button  */}
        {!isActive ? "▲▼" : sortOrder === "asc" ? "▲" : "▼"}
      </span>
    );
  };

  // handle the sort with consistency icons and defualt sort asc .
  const handleSort = (column) => {
    if (sortColumn === column) {
      // Same column -> toggle
      const newIsAsc = !isAsc;
      setIsAsc(newIsAsc);
      setSortOrder(newIsAsc ? "asc" : "desc");
    } else {
      // Different column -> default to ascending
      setSortColumn(column);
      setIsAsc(true);
      setSortOrder("asc");
    }

    setCurrentPage(0);
  };

  const paginatedClients = clients;

  // ---------------- ACTIONS ----------------

const handleApprove = async (client) => {
  try {
    setProcessing(true);
    setActionState({ id: client.id, type: "approve" });

    // navigate(`/admin/client-pricing/${client.id}`, {
    //   state: {
    //     client,
    //   },
    // });
    // approve the client .
    // Approve client
    await approveClient(client.id);

    toast.success("Client approved successfully.");

    await loadClients();

  } catch (err) {
    toast.error("Failed to approve client");
  } finally {
    setProcessing(false);
    setActionState({ id: null, type: null });
  }
};


  const handleReject = async (id) => {
    if (!rejectReason.trim()) {
      toast.error("Please enter rejection reason");
      return;
    }

    try {
      setProcessing(true);
      setActionState({ id, type: "reject" });

      await rejectClient(id, rejectReason);

      toast.success("Client rejected");
      setRejectReason("");

      loadClients(); // ✅ refetch
    } catch {
      toast.error("Failed to reject client");
    } finally {
      setProcessing(false);
      setActionState({ id: null, type: null });
    }
  };

  // ---------------- UI ----------------

return (
  <div className="client-wrapper">

    {/* Back Button */}
    <div className="pending-clients-back-wrapper">
      <button
        type="button"
        className="pending-clients-back-button"
         onClick={() => navigate(-1)}
      >
        <ArrowLeft size={18} />
        <span>Back</span>
      </button>
    </div>

    <div className="clinet-table-controls">
        <div className="entries-select">
          Show{" "}
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(0);
            }}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>{" "}
          entries
        </div>

        <div className="client-search-box">
          <div className="client-search-input-wrapper">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(0);
              }}
            />
            <Search className="client-search-icon" size={18} />
          </div>
        </div>
      </div>

      <div className="clinet-table-container">
        <table className="candidates-clinet-table">
          <thead>
            <tr>
              <th onClick={() => handleSort("username")}>
                Client Name {renderSortArrow("username")}
                {/* {sortColumn === 'username' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
              </th>
              <th onClick={() => handleSort("companyname")}>
                Company {renderSortArrow("companyname")}
                {/* {sortColumn === 'companyname' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
              </th>
              <th onClick={() => handleSort("email")}>
                Email {renderSortArrow("email")}
                {/* {sortColumn === 'email' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
              </th>
              <th onClick={() => handleSort("phonenumber")}>
                Contact Number {renderSortArrow("phonenumber")}
                {/* {sortColumn === 'phonenumber' ? (sortOrder === 'asc' ? '↑' : '↓') : '↑↓'} */}
              </th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="no-data loading-text">
                  Loading Pending Clients...
                </td>
              </tr>
            ) : paginatedClients.length > 0 ? (
              paginatedClients.map((client) => (
                <tr key={client.id}>
                  <td>{client.username}</td>
                  <td>{client.companyName}</td>
                  <td>{client.email}</td>
                  <td>{client.phoneNumber}</td>

                  <td style={{ display: "flex", gap: "8px" }}>
                    <button
                      className="candidate-btn"
                      disabled={processing}
                      onClick={() =>
                        setConfirmModal({
                          open: true,
                          id: client.id,
                          type: "approve",
                        })
                      }
                    >
                      {actionState.id === client.id &&
                      actionState.type === "approve"
                        ? "Approving..."
                        : "Approve"}
                    </button>

                    <button
                      className="candidate-btn"
                      style={{ backgroundColor: "#8b0000" }}
                      disabled={processing}
                      onClick={() =>
                        setConfirmModal({
                          open: true,
                          id: client.id,
                          type: "reject",
                        })
                      }
                    >
                      {actionState.id === client.id &&
                      actionState.type === "reject"
                        ? "Rejecting..."
                        : "Reject"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-data">
                  No pending clients found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ BACKEND PAGINATION */}
      <div className="pagination">
        <div className="pagination-summary">
          {totalElements === 0 ? (
            <>Showing 0 to 0 of 0 entries</>
          ) : (
            <>
              Showing {currentPage * pageSize + 1} to{" "}
              {currentPage * pageSize + clients.length} of {totalElements}{" "}
              entries
            </>
          )}
        </div>

        <div className="pagination-buttons-user">
          <button
            className="page-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
            disabled={currentPage === 0}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`page-btn ${currentPage === index ? "active" : ""}`}
              onClick={() => setCurrentPage(index)}
            >
              {index + 1}
            </button>
          ))}

          <button
            className="page-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))
            }
            disabled={currentPage >= totalPages - 1 || totalPages === 0}
          >
            Next
          </button>
        </div>
      </div>

      {/* ✅ KEEP MODAL EXACT SAME */}
      {confirmModal.open && (
        <div
          className="confirm-overlay"
          onClick={() => setConfirmModal({ open: false, id: null, type: null })}
        >
          <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="confirm-close-btn"
              onClick={() =>
                setConfirmModal({ open: false, id: null, type: null })
              }
            >
              ✕
            </button>

            <h3 className="confirm-title">
              {confirmModal.type === "approve"
                ? "Approve Client?"
                : "Reject Client?"}
            </h3>

            <p>
              Are you sure you want to <strong>{confirmModal.type}</strong> this
              client?
            </p>

            {confirmModal.type === "reject" && (
              <div style={{ marginTop: "10px" }}>
                <textarea
                  placeholder="Enter reason for rejection (max 200 characters)"
                  maxLength={200}
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  style={{
                    width: "100%",
                    minHeight: "80px",
                    padding: "8px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    resize: "none",
                  }}
                />
                <div style={{ fontSize: "12px", textAlign: "right" }}>
                  {rejectReason.length}/200
                </div>
              </div>
            )}

            <div className="confirm-actions">
              <button
                className="confirm-btn yes"
                onClick={() => {
                  if (confirmModal.type === "approve") {
                    const client = clients.find(
                      (c) => c.id === confirmModal.id,
                    );
                    handleApprove(client);
                    setConfirmModal({ open: false, id: null, type: null });
                  } else {
                    if (!rejectReason.trim()) {
                      toast.error("Please enter rejection reason");
                      return;
                    }

                    handleReject(confirmModal.id);
                    setConfirmModal({ open: false, id: null, type: null });
                  }
                }}
              >
                Yes
              </button>

              <button
                className="confirm-btn no"
                onClick={() => {
                  setConfirmModal({ open: false, id: null, type: null });
                  setRejectReason("");
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingClients;
